export default __webpack_public_path__ + "assets/images/92d2de24bd759f8f0094faba22aaf057.png";